/* Shared commerce primitives. Shopify option strings are opaque; never split sizes or normalize dashes. */
((global) => {
  'use strict';
  function createVariantResolver(variants) {
    const byOptions = new Map();
    variants.forEach(variant => { if (Array.isArray(variant.options)) byOptions.set(JSON.stringify(variant.options), variant); });
    return values => values.every(value => typeof value === 'string') ? byOptions.get(JSON.stringify(values)) || null : null;
  }
  function createStripeLoader(win, doc) {
    let promise = null;
    return function loadStripe() {
      if (typeof win.Stripe === 'function') return Promise.resolve(win.Stripe);
      if (promise) return promise;
      const attempt = new Promise((resolve, reject) => {
        let script = [...doc.querySelectorAll('script[src]')].find(element => {
          try { const url = new URL(element.src, doc.baseURI); return url.origin === 'https://js.stripe.com' && url.pathname.replace(/\/$/, '') === '/v3'; }
          catch { return false; }
        });
        const created = !script;
        if (!script) { script = doc.createElement('script'); script.src = 'https://js.stripe.com/v3/'; script.async = true; script.dataset.vaytrixStripeJs = 'true'; }
        let settled = false;
        // Timeout is a controlled failure boundary, never an initialization delay.
        const timeout = win.setTimeout(() => finish(new Error('Secure checkout took too long to load. Please try again.')), 20000);
        function finish(error) {
          if (settled) return;
          settled = true; win.clearTimeout(timeout);
          script.removeEventListener('load', onLoad); script.removeEventListener('error', onError);
          if (error) {
            // A failed v3 tag cannot recover; replace it on the next user-initiated retry, including external tags.
            script.remove();
            reject(error);
          } else resolve(win.Stripe);
        }
        const onLoad = () => finish(typeof win.Stripe === 'function' ? null : new Error('Secure checkout is unavailable. Please try again.'));
        const onError = () => finish(new Error('Secure checkout could not load. Check your connection and try again.'));
        script.addEventListener('load', onLoad, { once: true }); script.addEventListener('error', onError, { once: true });
        if (typeof win.Stripe === 'function') { onLoad(); return; }
        if (created) doc.head.appendChild(script);
        // Handles an already-loaded existing tag without an available Stripe global.
        else if (script.readyState === 'complete' || script.readyState === 'loaded') onLoad();
      });
      promise = attempt.catch(error => { promise = null; throw error; });
      return promise;
    };
  }
  const commerce = { createVariantResolver, createStripeLoader };
  if (typeof module !== 'undefined' && module.exports) module.exports = commerce;
  else global.VaytrixCommerce = commerce;
})(typeof window !== 'undefined' ? window : globalThis);
